export default __webpack_public_path__ + "static/linear-action-3366c0114c190d6b224bf27bcaa6c043.png";